export default __webpack_public_path__ + "static/media/lydyanah.b1fedf08.jpg";